export default {
  consulars: {
    consularRemoved: 'Consular removed',
    consularUpdated: 'Consular updated',
    consularAdded: 'Consular added',
    consulars: 'Consulars',
    consular: 'Consular',
  }
}
